import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { place_order, fetch_my_orders, cancel_my_order, fetch_vendor_orders, transition_order } from './api';
import type { OrderStatus, OrderIntent, PlaceOrderInput } from './types';

export function use_my_orders() {
  return useQuery({ queryKey: ['my-orders'], queryFn: fetch_my_orders });
}

export function use_place_order() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: PlaceOrderInput) => place_order(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['my-orders'] }),
  });
}

export function use_cancel_my_order() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason?: string }) => cancel_my_order(id, reason),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['my-orders'] }),
  });
}

export function use_vendor_orders(status?: OrderStatus) {
  return useQuery({ queryKey: ['vendor-orders', status ?? 'all'], queryFn: () => fetch_vendor_orders(status) });
}

export function use_transition_order() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, intent, reason }: { id: string; intent: OrderIntent; reason?: string }) => transition_order(id, intent, reason),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['vendor-orders'] }),
  });
}
